/* Saans theme scripts */
(function(){
  'use strict';
  var money = window.Saans && window.Saans.moneyFormat ? window.Saans.moneyFormat : '\u20b9{{amount}}';

  function formatMoney(cents){
    var v = (cents/100);
    var noDecimals = /no_decimals/.test(money);
    var s = (v % 1 === 0 || noDecimals) ? Math.round(v).toString() : v.toFixed(2);
    // Indian-style thousands grouping (last 3, then pairs)
    var parts = s.split('.');
    var intp = parts[0];
    var lastThree = intp.length > 3 ? intp.slice(-3) : intp;
    var rest = intp.length > 3 ? intp.slice(0, -3) : '';
    if(rest) lastThree = rest.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + ',' + lastThree;
    s = lastThree + (parts[1] ? '.' + parts[1] : '');
    // replace any {{ token }} in the format string
    return money.replace(/\{\{\s*\w+\s*\}\}/g, s);
  }
  window.SaansFormatMoney = formatMoney;

  /* Gift Wrap is a paid add-on, not a saree/cart-count item. */
  function isGiftWrapItem(it){
    if(!it) return false;
    var handle=String(it.handle||it.product_handle||'').toLowerCase();
    var title=String(it.product_title||it.title||'').trim().toLowerCase();
    var url=String(it.url||'').toLowerCase();
    return handle==='gift-wrap' || title==='gift wrap' || url.indexOf('/products/gift-wrap')!==-1;
  }
  function sareeItemCount(cart){
    if(!cart || !Array.isArray(cart.items)) return 0;
    return cart.items.reduce(function(n,it){
      return n + (isGiftWrapItem(it) ? 0 : (parseInt(it.quantity,10)||0));
    },0);
  }
  window.SaansSareesItemCount = sareeItemCount;

  /* ---------- Mobile menu drawer ---------- */
  function openDrawer(id,celebrate){var d=document.getElementById(id);if(d){d.classList.add('open');document.body.style.overflow='hidden';if(id==='cart-drawer'&&celebrate){setTimeout(saansConfetti,60);}}}
  function closeDrawer(id){var d=document.getElementById(id);if(d){d.classList.remove('open');document.body.style.overflow='';}}
  document.addEventListener('click', function(e){
    var o=e.target.closest('[data-drawer-open]'); if(o){e.preventDefault();openDrawer(o.getAttribute('data-drawer-open'));}
    var c=e.target.closest('[data-drawer-close]'); if(c){e.preventDefault();closeDrawer(c.getAttribute('data-drawer-close'));}
  });

  /* ---------- Generic carousel (hero, product gallery) ---------- */
  window.SaansCarousel = function(trackId, count, dotSel, thumbSel){
    var t=document.getElementById(trackId); if(!t) return;
    var i=0, N=count;
    function go(n){
      i=(n+N)%N;
      t.style.transform='translateX('+(-i*100)+'%)';
      if(dotSel) document.querySelectorAll(dotSel).forEach(function(e,j){e.classList.toggle('on',j===i);});
      if(thumbSel) document.querySelectorAll(thumbSel).forEach(function(e,j){e.classList.toggle('active',j===i);});
    }
    t.__go=go; t.__idx=function(){return i;};
    // swipe
    var x0=null;
    t.addEventListener('touchstart',function(e){if(e.touches.length===1)x0=e.touches[0].clientX;},{passive:true});
    t.addEventListener('touchend',function(e){if(x0===null)return;var dx=e.changedTouches[0].clientX-x0;if(Math.abs(dx)>45){dx<0?go(i+1):go(i-1);}x0=null;});
    return go;
  };

  /* ---------- Accordion ---------- */
  window.saansAcc = function(btn){ btn.parentElement.classList.toggle('open'); };
  window.saansFootToggle = function(h){ if(window.innerWidth<=700){ h.parentElement.classList.toggle('open'); } };

  /* ---------- Quantity ---------- */
  window.saansQty = function(el, d){
    var wrap = el.closest('.qty');
    var input = wrap ? wrap.querySelector('input,[data-qv]') : null;
    if(!input) return;

    var current = parseInt(input.tagName === 'INPUT' ? input.value : input.textContent,10) || 1;
    var next = Math.max(1, current + d);
    var maxAttr = input.getAttribute ? input.getAttribute('max') : null;
    var max = maxAttr !== null && maxAttr !== '' ? parseInt(maxAttr,10) : NaN;

    if(Number.isFinite(max)) next = Math.min(next, Math.max(1,max));

    if(input.tagName === 'INPUT') input.value = next;
    else input.textContent = next;

    var plus = wrap.querySelector('[data-qty-plus]') || wrap.querySelector('button:last-child');
    if(plus && Number.isFinite(max)) plus.disabled = next >= max;
  };

  /* Clamp manually typed product quantities to available stock. */
  document.addEventListener('input', function(e){
    var input=e.target;
    if(!input || !input.matches || !input.matches('input[data-qv]')) return;
    var max=parseInt(input.getAttribute('max'),10);
    var v=parseInt(input.value,10);
    if(Number.isFinite(max) && Number.isFinite(v) && v>max) input.value=max;
    if(Number.isFinite(v) && v<1) input.value=1;
    var wrap=input.closest('.qty');
    var plus=wrap && (wrap.querySelector('[data-qty-plus]') || wrap.querySelector('button:last-child'));
    if(plus && Number.isFinite(max)) plus.disabled=(parseInt(input.value,10)||1)>=max;
  });

  /* ---------- Pincode checker (estimate only) ---------- */
  window.saansCheckPin = function(){
    var el=document.getElementById('pin'); if(!el) return;
    var p=(el.value||'').trim();
    if(p.length!==6 || /\D/.test(p)){ alert('Please enter a valid 6-digit pincode'); return; }
    try{localStorage.setItem('saans_pincode',p);}catch(e){}
    var dEl=document.getElementById('pinDate');if(dEl)dEl.textContent=window.Saans.delivery_note;
    var cEl=document.getElementById('pinCod');if(cEl)cEl.textContent='Payment methods are confirmed at checkout.';
    var res=document.getElementById('pinres');if(res)res.classList.add('on');
  };

  /* ---------- Cart count refresh ---------- */
  function refreshCartCount(){
    fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(c){
      var visibleCount=sareeItemCount(c);
      document.querySelectorAll('[data-cart-count]').forEach(function(el){
        el.textContent=visibleCount;
        el.style.display=visibleCount>0?'grid':'none';
      });
    }).catch(function(){});
  }
  window.saansRefreshCart = refreshCartCount;
  refreshCartCount();

  /* ---------- Confetti burst (fires in cart drawer on add) ---------- */
  function saansConfetti(){
    var host=document.getElementById('cart-drawer')||document.body;
    var cv=document.createElement('canvas');
    cv.className='glint-confetti';
    cv.style.cssText='position:absolute;inset:0;width:100%;height:100%;pointer-events:none;z-index:90';
    host.appendChild(cv);
    var rect=host.getBoundingClientRect();
    var W=cv.width=Math.max(1,rect.width), H=cv.height=Math.max(1,rect.height);
    var ctx=cv.getContext('2d');
    var colors=['#f5b301','#b1473f','#16a89b','#c9a44e','#e8a0b4','#4a6fa5','#3a7d5d','#8e7cc3'];
    var N=90, P=[];
    for(var i=0;i<N;i++){
      P.push({x:W/2,y:H*0.28,vx:(Math.random()-0.5)*9,vy:Math.random()*-8-3,
        g:0.28+Math.random()*0.12,s:5+Math.random()*6,r:Math.random()*6.28,
        vr:(Math.random()-0.5)*0.3,c:colors[(Math.random()*colors.length)|0]});
    }
    var start=null, DUR=1500;
    function frame(t){
      if(start===null)start=t; var el=t-start;
      ctx.clearRect(0,0,W,H);
      for(var i=0;i<P.length;i++){var p=P[i];
        p.vy+=p.g; p.x+=p.vx; p.y+=p.vy; p.r+=p.vr;
        ctx.save(); ctx.translate(p.x,p.y); ctx.rotate(p.r);
        ctx.globalAlpha=Math.max(0,1-el/DUR);
        ctx.fillStyle=p.c; ctx.fillRect(-p.s/2,-p.s/2,p.s,p.s*0.6);
        ctx.restore();
      }
      if(el<DUR){requestAnimationFrame(frame);}else if(cv.parentNode){cv.parentNode.removeChild(cv);}
    }
    requestAnimationFrame(frame);
  }

  /* ---------- AJAX add to cart ---------- */
  /*
     IMPORTANT: do not use a real form submit for storefront Add to Cart.
     Shopify Customer Events can observe both the submit action and the AJAX cart mutation,
     which caused one shopper click to emit two product_added_to_cart events.
     All standard ATC buttons now call this one shared function directly.
  */
  function addFormToCart(form, triggerButton){
    if(!form || !form.matches || !form.matches('form[data-add-to-cart]')) return Promise.resolve(false);

    var btn=triggerButton || form.querySelector('[data-add-to-cart-button]');
    if(btn && btn.disabled) return Promise.resolve(false);

    var orig=btn?btn.innerHTML:'';
    var qtyInput=form.querySelector('[name="quantity"]');
    var variantInput=form.querySelector('[name="id"]');
    var requested=Math.max(1, parseInt(qtyInput && qtyInput.value,10) || 1);
    var variantId=variantInput ? String(variantInput.value) : '';
    var limit=qtyInput ? parseInt(qtyInput.getAttribute('data-stock-limit') || qtyInput.getAttribute('max'),10) : NaN;

    function restoreButton(){
      if(btn){ btn.innerHTML=orig; btn.disabled=false; }
    }

    function finishSuccessfulAdd(){
      refreshCartCount();
      if(btn){
        btn.innerHTML='Added \u2713';
        setTimeout(function(){
          btn.innerHTML=orig;
          btn.disabled=false;
          var max=parseInt(qtyInput && qtyInput.getAttribute('max'),10);
          if(qtyInput && Number.isFinite(max)){
            var v=parseInt(qtyInput.value,10)||1;
            var plus=qtyInput.closest('.qty') && qtyInput.closest('.qty').querySelector('[data-qty-plus]');
            if(plus) plus.disabled=v>=max;
          }
        },1400);
      }
      openDrawer('cart-drawer', true);
      loadCartDrawer();
      return true;
    }

    function runAfterSareesAdd(){
      if(typeof window.saansAfterSareesAdd!=='function') return Promise.resolve();
      try{
        return Promise.resolve(window.saansAfterSareesAdd()).catch(function(){/* Sarees was added; don't fail the ATC if gift-wrap sync fails. */});
      }catch(e){
        return Promise.resolve();
      }
    }

    function doAdd(quantity){
      if(qtyInput) qtyInput.value=quantity;
      if(btn){btn.disabled=true;btn.innerHTML='Adding\u2026';}
      return fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)})
        .then(function(r){ if(!r.ok) return r.json().then(function(x){throw x;}); return r.json(); })
        .then(function(){ return runAfterSareesAdd(); })
        .then(finishSuccessfulAdd)
        .catch(function(err){
          restoreButton();
          /* Shopify remains the final inventory authority if stock changed meanwhile. */
          alert((err&&err.description)||'This quantity is no longer available. Please refresh and try again.');
          loadCartDrawer();
          return false;
        });
    }

    /* For tracked variants, also account for units of the same variant already in cart.
       This prevents 1-in-stock + repeated Add to Cart from becoming quantity 2+. */
    if(Number.isFinite(limit) && variantId){
      if(limit<=0){
        restoreButton();
        alert('This item is currently out of stock.');
        return Promise.resolve(false);
      }
      if(btn){btn.disabled=true;btn.innerHTML='Checking stock\u2026';}
      return fetch('/cart.js',{headers:{'Accept':'application/json'}})
        .then(function(r){return r.json();})
        .then(function(cart){
          var already=0;
          (cart.items||[]).forEach(function(it){
            if(String(it.variant_id)===variantId) already += (parseInt(it.quantity,10)||0);
          });
          var remaining=Math.max(0,limit-already);

          if(remaining<=0){
            restoreButton();
            if(qtyInput) qtyInput.value=1;
            alert('Only '+limit+' available and '+(limit===1?'it is':'they are')+' already in your cart.');
            openDrawer('cart-drawer');
            loadCartDrawer();
            return false;
          }

          var finalQty=Math.min(requested,remaining);
          if(finalQty<requested){
            if(qtyInput) qtyInput.value=finalQty;
            alert('Only '+limit+' available. Quantity has been adjusted to '+finalQty+'.');
          }
          return doAdd(finalQty);
        })
        .catch(function(){
          /* If preflight itself fails, let Shopify validate the real add request. */
          return doAdd(Math.min(requested,limit));
        });
    }
    return doAdd(requested);
  }
  window.saansAddToCart=addFormToCart;

  /* Standard product-page and product-card buttons use a click, not form submit. */
  document.addEventListener('click', function(e){
    var btn=e.target.closest('[data-add-to-cart-button]');
    if(!btn) return;
    var form=btn.closest('form[data-add-to-cart]');
    if(!form) return;
    e.preventDefault();
    addFormToCart(form,btn);
  });

  /* ---------- Complete the set: add matching pair ---------- */
  document.addEventListener('click', function(e){
    var b=e.target.closest('.pdp-set-add[data-add-id]');
    if(!b) return;
    e.preventDefault();
    var id=b.getAttribute('data-add-id'); if(!id) return;
    var orig=b.textContent; b.disabled=true; b.textContent='Adding\u2026';
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:id,quantity:1})})
      .then(function(r){ if(!r.ok) return r.json().then(function(x){throw x;}); return r.json(); })
      .then(function(){ refreshCartCount(); b.textContent='Added \u2713'; setTimeout(function(){b.textContent=orig;b.disabled=false;},1400); openDrawer('cart-drawer', true); loadCartDrawer(); })
      .catch(function(err){ b.textContent=orig; b.disabled=false; alert((err&&err.description)||'Could not add'); });
  });


  /* ---------- Cart drawer quick-add button ---------- */
  document.addEventListener('click', function(e){
    var b=e.target.closest('.cd-qa-add[data-add-id]');
    if(!b) return;
    e.preventDefault();
    var id=b.getAttribute('data-add-id'); if(!id) return;
    var orig=b.textContent; b.disabled=true; b.textContent='Adding\u2026';
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:id,quantity:1})})
      .then(function(r){ if(!r.ok) return r.json().then(function(x){throw x;}); return r.json(); })
      .then(function(){ refreshCartCount(); loadCartDrawer(); })
      .catch(function(err){ b.textContent=orig; b.disabled=false; alert((err&&err.description)||'Could not add'); });
  });

  document.addEventListener('click', function(e){
    var b=e.target.closest('.cd-petticoat-add[data-add-id]');
    if(!b) return;
    e.preventDefault();
    var id=b.getAttribute('data-add-id'); if(!id) return;
    var orig=b.textContent; b.disabled=true; b.textContent='Adding…';
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:id,quantity:1})})
      .then(function(r){if(!r.ok)return r.json().then(function(x){throw x;});return r.json();})
      .then(function(){refreshCartCount();loadCartDrawer();})
      .catch(function(err){b.textContent=orig;b.disabled=false;alert((err&&err.description)||'Could not add petticoat');});
  });

  /* ---------- Compact dynamic bundle nudge (drawer) ---------- */
  function buildGiftNudge(){
    if(!window.Saans.offers_enabled)return "";
    return '<div class="gl-bundle-progress gl-bundle-progress--drawer" data-gl-bundle-progress aria-live="polite">'+
      '<span class="gl-bundle-star gl-bundle-star--one" aria-hidden="true">&#10022;</span>'+
      '<span class="gl-bundle-star gl-bundle-star--two" aria-hidden="true">&#10022;</span>'+
      '<span class="gl-bundle-icon" data-gl-bundle-icon aria-hidden="true"></span>'+
      '<span class="gl-bundle-copy">'+
        '<span class="gl-bundle-primary" data-gl-bundle-primary></span>'+
        '<span class="gl-bundle-bottom">'+
          '<a class="gl-bundle-next" data-gl-bundle-next href="/collections/all"></a>'+
          '<span class="gl-bundle-meter-wrap">'+
            '<span class="gl-bundle-meter"><span class="gl-bundle-fill" data-gl-bundle-fill></span></span>'+
            '<span class="gl-bundle-count" data-gl-bundle-count></span>'+
          '</span>'+
        '</span>'+
      '</span>'+
    '</div>';
  }

  /* ---------- Cart drawer contents ---------- */
  var cdLoadSeq=0;

  function drawerVariantMeta(cart, seq){
    var items=cart&&cart.items?cart.items:[];
    if(!items.length) return Promise.resolve({mrpTotal:0});
    var byHandle={}, jobs=[];
    items.forEach(function(it){
      if(!it.handle || byHandle[it.handle]) return;
      byHandle[it.handle]=true;
      jobs.push(
        fetch('/products/'+encodeURIComponent(it.handle)+'.js',{headers:{'Accept':'application/json'}})
          .then(function(r){ return r.ok?r.json():null; })
          .then(function(p){ return {handle:it.handle,product:p}; })
          .catch(function(){ return {handle:it.handle,product:null}; })
      );
    });
    return Promise.all(jobs).then(function(rows){
      if(seq!==cdLoadSeq) return {mrpTotal:0,stale:true};
      var products={}; rows.forEach(function(x){ products[x.handle]=x.product; });
      var mrpTotal=0;
      items.forEach(function(it){
        var p=products[it.handle], v=null;
        var secondImage=p&&p.images&&p.images.length>1?p.images[1]:'';
        if(secondImage){
          var drawerImages=document.querySelectorAll('.cd-thumb img[data-product-id="'+it.product_id+'"]');
          for(var imageIndex=0;imageIndex<drawerImages.length;imageIndex++){
            drawerImages[imageIndex].src=secondImage;
          }
        }
        if(p&&p.variants){
          for(var i=0;i<p.variants.length;i++){
            if(String(p.variants[i].id)===String(it.variant_id)){ v=p.variants[i]; break; }
          }
        }
        var selling=(it.original_price||it.price||0);
        var compare=v&&v.compare_at_price?parseInt(v.compare_at_price,10):0;
        var mrp=(compare>selling)?compare:selling;
        mrpTotal += mrp*(it.quantity||1);

        var strike=document.querySelector('.cd-mrp[data-variant-id="'+it.variant_id+'"]');
        if(strike && compare>selling){
          strike.textContent=formatMoney(compare*(it.quantity||1));
          strike.classList.add('on');
        }
      });
      return {mrpTotal:mrpTotal};
    });
  }

  function updateDrawerSummary(cart, seq){
    var sub=document.getElementById('cart-drawer-sub');
    var total=document.getElementById('cart-drawer-total');
    var cnt=document.getElementById('cart-drawer-count');
    var plural=document.getElementById('cart-drawer-count-plural');
    var drow=document.getElementById('cart-drawer-discount-row');
    var dval=document.getElementById('cart-drawer-discount');
    var mrow=document.getElementById('cart-drawer-mrp-row');
    var mval=document.getElementById('cart-drawer-mrp-save');
    var applied=document.getElementById('cart-drawer-applied');

    if(sub) sub.textContent=formatMoney(cart.original_total_price||cart.total_price||0);
    if(total) total.textContent=formatMoney(cart.total_price||0);
    var visibleCount=sareeItemCount(cart);
    if(cnt) cnt.textContent=visibleCount;
    if(plural) plural.textContent=(visibleCount===1)?'':'s';

    var discount=cart.total_discount||0;
    if(drow){ drow.style.display=discount>0?'flex':'none'; }
    if(dval){ dval.textContent=discount>0?('-'+formatMoney(discount)):''; }

    if(applied){
      if(discount>0){ applied.style.display='block'; applied.textContent='Discount applied — you saved '+formatMoney(discount); }else{ applied.style.display='none'; applied.textContent=''; }
    }

    drawerVariantMeta(cart,seq).then(function(meta){
      if(!meta || meta.stale || seq!==cdLoadSeq) return;
      var mrpSavings=Math.max(0,(meta.mrpTotal||0)-(cart.original_total_price||0));
      if(mrow) mrow.style.display=mrpSavings>0?'flex':'none';
      if(mval) mval.textContent=mrpSavings>0?('-'+formatMoney(mrpSavings)):'';
    });
  }

  function loadCartDrawer(){
    var wrap=document.getElementById('cart-drawer-body'); if(!wrap) return;
    var foot=document.getElementById('cart-drawer-foot');
    var seq=++cdLoadSeq;
    if(!wrap.querySelector('.cd-item')){ wrap.innerHTML='<div class="cd-skel"></div><div class="cd-skel"></div>'; }
    if(foot){ foot.style.display='block'; }
    fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(cart){
      if(seq!==cdLoadSeq) return;
      var visibleCount=sareeItemCount(cart);
      if(visibleCount===0){ wrap.innerHTML=(window.cdEmptyHtml?window.cdEmptyHtml():'<div class="empty-note">Your cart is empty.</div>'); if(foot)foot.style.display='none'; return; }
      var html='';
      cart.items.forEach(function(it){
        if(isGiftWrapItem(it)) return;
        html+='<div class="cd-item">'+
          '<div class="cd-thumb">'+(it.image?'<img src="'+it.image+'" alt="" data-product-id="'+it.product_id+'">':'')+'</div>'+
          '<div class="cd-info"><div class="cd-t">'+it.product_title+'</div>'+
          (it.variant_title&&it.variant_title!=='Default Title'?'<div class="cd-v">'+it.variant_title+'</div>':'')+
          '<div class="cd-row"><div class="qty sm"><button type="button" data-cd-change="'+it.key+'" data-cd-d="-1" data-variant-id="'+it.variant_id+'">\u2212</button><span>'+it.quantity+'</span><button type="button" data-cd-change="'+it.key+'" data-cd-d="1" data-variant-id="'+it.variant_id+'"'+((window.SAANS_STOCK_LIMITS&&Number.isFinite(window.SAANS_STOCK_LIMITS[String(it.variant_id)]))?' data-cd-max="'+window.SAANS_STOCK_LIMITS[String(it.variant_id)]+'"':'')+'>+</button></div>'+
          '<div class="cd-price"><span>'+formatMoney(it.original_line_price)+'</span><s class="cd-mrp" data-variant-id="'+it.variant_id+'"></s></div></div></div></div>';
      });
      var hasPetticoat=cart.items.some(function(it){return String(it.product_title||'').toLowerCase().indexOf('petticoat')!==-1;});
      var hasSaree=cart.items.some(function(it){return String(it.product_type||'').toLowerCase().indexOf('saree')!==-1 || /saree/i.test(it.product_title||'');});
      var petticoatOffer='';
      if(hasSaree && !hasPetticoat){
        petticoatOffer='<section class="cd-petticoat-offer" aria-label="Matching petticoat add-on">'+
          '<div class="cd-petticoat-product-row">'+
          '<img class="cd-petticoat-image" src="https://cdn.shopify.com/s/files/1/1010/2708/6611/files/saans-adjustable-petticoat-peach_ef4ccd7a-1cec-4d7a-968a-d2173d4eda42.png?v=1791805577" alt="Peach adjustable saree petticoat" loading="lazy">'+
          '<div class="cd-petticoat-product-info">'+
          '<div class="cd-petticoat-kicker">COMPLETE YOUR DRAPE</div>'+
          '<div class="cd-petticoat-title">Everyday Adjustable Petticoat</div>'+
          '<p class="cd-petticoat-copy">₹399 · Free size, adjustable waist</p>'+
          '</div></div>'+
          '<p class="cd-petticoat-note">We’ll suggest a coordinating shade for your saree. Colour availability must be confirmed before dispatch.</p>'+
          '<a class="cd-petticoat-colours-link" href="/search?q=petticoat">Want another colour? View all colours</a>'+
          '<button type="button" class="cd-petticoat-add" data-add-id="67645340877075">+ Add petticoat · ₹399</button>'+
        '</section>';
      }
      wrap.innerHTML=buildGiftNudge()+html+petticoatOffer;
      if(foot){ foot.style.display='block'; }
      updateDrawerSummary(cart,seq);
      if(window.saansBundleProgress){ window.saansBundleProgress(visibleCount, cart.total_price, cart.total_discount); }
      /* Recommendations intentionally removed from the drawer: keep the purchase path focused. */
    });
  }
  window.saansLoadCartDrawer = loadCartDrawer;

  /* ---------- Cart drawer: Shopify related-product quick-adds ---------- */
  function saansCartQuickAdds(cart){
    var body=document.getElementById('cart-drawer-body'); if(!body||!cart||!cart.items||!cart.items.length) return;
    var pid=cart.items[0].product_id;
    var have={}; cart.items.forEach(function(it){ have[it.product_id]=1; });
    fetch('/recommendations/products.json?product_id='+pid+'&intent=related&limit=8',{headers:{'Accept':'application/json'}})
      .then(function(r){return r.json();}).then(function(d){
        var list=(d&&d.products)||[], cards='', n=0, i, j;
        for(i=0;i<list.length && n<3;i++){
          var p=list[i]; if(!p||have[p.id]) continue;
          var vid=null; if(p.variants){ for(j=0;j<p.variants.length;j++){ if(p.variants[j].available){ vid=p.variants[j].id; break; } } if(vid===null && p.variants[0]) vid=p.variants[0].id; }
          if(!vid) continue;
          var img=p.featured_image?('<img src="'+p.featured_image+'" alt="" loading="lazy">'):'';
          cards+='<div class="cd-qa-card"><a class="cd-qa-lk" href="'+p.url+'"><div class="cd-qa-im">'+img+'</div><div class="cd-qa-t">'+p.title+'</div><div class="cd-qa-p">'+formatMoney(p.price)+'</div></a><button type="button" class="cd-qa-add" data-add-id="'+vid+'">+ Add</button></div>';
          n++;
        }
        var old=document.getElementById('cdQuickAdds'); if(old) old.remove();
        if(!n) return;
        body.insertAdjacentHTML('beforeend','<div class="cd-qa" id="cdQuickAdds"><div class="cd-qa-h">Top Deals &#128293; for you</div><div class="cd-qa-row">'+cards+'</div></div>');
      }).catch(function(){});
  }

  /* ---------- Bundle progress: compact next-tier message + one-time unlock animation ---------- */
  var glBundleGiftIcon='<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 10h16v10H4zM3 7h18v3H3zM12 7v13M7.5 7C5.6 7 4.5 6.1 4.5 4.8 4.5 3.7 5.4 3 6.5 3 8.4 3 10.1 5.1 12 7M16.5 7c1.9 0 3-.9 3-2.2 0-1.1-.9-1.8-2-1.8-1.9 0-3.6 2.1-5.5 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var glBundleCheckIcon='<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="m5 12.5 4.2 4.2L19 7" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function glBundleSetIcon(card, success){
    var icon=card.querySelector('[data-gl-bundle-icon]');
    if(icon){ icon.innerHTML=success?glBundleCheckIcon:glBundleGiftIcon; }
  }

  function glBundleRenderState(card, qty){
    var primary=card.querySelector('[data-gl-bundle-primary]');
    var next=card.querySelector('[data-gl-bundle-next]');
    var fill=card.querySelector('[data-gl-bundle-fill]');
    var count=card.querySelector('[data-gl-bundle-count]');
    if(!primary||!next||!fill||!count) return;

    card.classList.remove('is-progress','is-success','is-final','is-unlocking','is-celebrating');
    card.removeAttribute('data-unlock-qty');
    next.classList.remove('is-note');
    next.setAttribute('href','/collections/all');

    if(qty<=1){
      card.classList.add('is-progress');
      glBundleSetIcon(card,false);
      primary.innerHTML='Add 1 more pair to unlock <strong>&#8377;300 off</strong>';
      next.textContent='Shop another pair \u2192';
      fill.style.width=(Math.max(0,qty)/2*100)+'%';
      count.textContent=Math.max(0,qty)+' of 2';
    }else if(qty===2){
      card.classList.add('is-success');
      glBundleSetIcon(card,true);
      primary.innerHTML='<strong>&#8377;300</strong> saving unlocked';
      next.innerHTML='Add 1 more pair to unlock <strong>&#8377;1000 off</strong> \u2192';
      fill.style.width='66.6667%';
      count.textContent='2 of 3';
    }else if(qty===3){
      card.classList.add('is-success');
      glBundleSetIcon(card,true);
      primary.innerHTML='<strong>&#8377;1000</strong> saving unlocked';
      next.innerHTML='Add 1 more pair to unlock <strong>&#8377;1,000 off</strong> \u2192';
      fill.style.width='75%';
      count.textContent='3 of 4';
    }else{
      card.classList.add('is-success','is-final');
      glBundleSetIcon(card,true);
      primary.innerHTML='<strong>&#8377;1,000</strong> saving unlocked';
      next.textContent='Best bundle saving applied';
      next.removeAttribute('href');
      next.classList.add('is-note');
      fill.style.width='100%';
      count.textContent='4 of 4';
    }
  }

  function glBundleAnimateUnlock(card, qty){
    var reachedAmount=qty>=4?'1,000':qty===3?'500':'300';
    var primary=card.querySelector('[data-gl-bundle-primary]');
    var next=card.querySelector('[data-gl-bundle-next]');
    var fill=card.querySelector('[data-gl-bundle-fill]');
    var count=card.querySelector('[data-gl-bundle-count]');
    if(!primary||!next||!fill||!count){ glBundleRenderState(card,qty); return; }

    card.classList.remove('is-success','is-final');
    card.classList.add('is-progress','is-unlocking');
    card.setAttribute('data-unlock-qty',''+qty);
    glBundleSetIcon(card,false);
    primary.innerHTML='Add 1 more pair to unlock <strong>&#8377;'+reachedAmount+' off</strong>';
    next.textContent='';
    fill.style.transition='none';
    fill.style.width=(Math.max(0,qty-1)/qty*100)+'%';
    count.textContent=qty+' of '+qty;

    requestAnimationFrame(function(){
      requestAnimationFrame(function(){
        fill.style.transition='width .34s cubic-bezier(.2,.75,.25,1)';
        fill.style.width='100%';
      });
    });

    setTimeout(function(){
      if(!document.documentElement.contains(card)) return;
      card.classList.add('is-celebrating');
      glBundleSetIcon(card,true);
      primary.innerHTML='<strong>&#8377;'+reachedAmount+'</strong> saving unlocked';
    },350);

    setTimeout(function(){
      if(!document.documentElement.contains(card)) return;
      fill.style.transition='';
      glBundleRenderState(card,qty);
    },900);
  }

  window.saansBundleProgress=function(qty, total, discount){
    qty=qty||0;
    var TH=[2,3,4], next=null, i;
    for(i=0;i<TH.length;i++){ if(qty<TH[i]){ next=TH[i]; break; } }
    var prev=null; try{ var v=sessionStorage.getItem('glPrevQty'); prev=(v===null)?null:parseInt(v,10); }catch(e){}
    var reached=null;
    if(prev!==null && qty>prev){ for(i=0;i<TH.length;i++){ if(TH[i]>prev && TH[i]<=qty){ reached=TH[i]; } } }
    try{ sessionStorage.setItem('glPrevQty', ''+qty); }catch(e){}
    var strips=document.querySelectorAll('.otn2-chips:not(.otn2-auto)');
    for(var s=0;s<strips.length;s++){
      var chips=strips[s].children;
      for(var k=0;k<chips.length && k<3;k++){
        var chip=chips[k], th=TH[k];
        chip.classList.remove('chip-next','chip-done');
        if(th<=qty){ chip.classList.add('chip-done'); }
        if(th===next){ chip.classList.add('chip-next'); }
        if(th===reached){ (function(c){ c.classList.add('chip-hit'); setTimeout(function(){ c.classList.remove('chip-hit'); },1700); })(chip); }
      }
    }
    var cards=document.querySelectorAll('[data-gl-bundle-progress]');
    for(var c=0;c<cards.length;c++){
      var card=cards[c];
      if(card.classList.contains('is-unlocking') && card.getAttribute('data-unlock-qty')===''+qty) continue;
      if(reached && qty>=2){ glBundleAnimateUnlock(card,qty); }
      else{ glBundleRenderState(card,qty); }
    }
  };
  function initBundle(){ fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(c){ window.saansBundleProgress(sareeItemCount(c), c.total_price, c.total_discount); }).catch(function(){}); }
  function bundleAuto(){
    var strips=document.querySelectorAll('.otn2-auto');
    for(var s=0;s<strips.length;s++){
      (function(strip){
        var chips=strip.children, n=Math.min(3,chips.length), idx=0;
        if(!n){ return; }
        function tick(){ for(var k=0;k<chips.length;k++){ chips[k].classList.remove('chip-next'); } if(chips[idx]){ chips[idx].classList.add('chip-next'); } idx=(idx+1)%n; }
        tick(); setInterval(tick, 1100);
      })(strips[s]);
    }
  }
  function bundleInit(){ if(window.Saans.offers_enabled){initBundle(); bundleAuto();} }
  if(document.readyState!=='loading'){ bundleInit(); } else { document.addEventListener('DOMContentLoaded', bundleInit); }

  document.addEventListener('click', function(e){
    var b=e.target.closest('[data-cd-change]');
    if(!b) return;
    var key=b.getAttribute('data-cd-change'), d=parseInt(b.getAttribute('data-cd-d'),10);
    var span=b.parentElement.querySelector('span');
    var current=parseInt(span.textContent,10)||0;
    var q=Math.max(0,current+d);
    var max=parseInt(b.getAttribute('data-cd-max'),10);

    if(d>0 && Number.isFinite(max) && q>max){
      alert('Only '+max+' available in stock.');
      return;
    }

    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:q})})
      .then(function(r){
        if(!r.ok) return r.json().then(function(x){throw x;});
        return r.json();
      })
      .then(function(){ loadCartDrawer(); refreshCartCount(); })
      .catch(function(err){
        alert((err&&err.description)||'That quantity is no longer available.');
        loadCartDrawer();
        refreshCartCount();
      });
  });

  /* ---------- Collection filter drawer ---------- */
  window.saansFilters = function(open){
    var f=document.getElementById('filters'), bg=document.getElementById('fbg');
    if(f) f.classList.toggle('open',!!open);
    if(bg) bg.classList.toggle('open',!!open);
  };
})();

/* ---------- premium scroll reveal ---------- */
(function(){
  try{
    document.documentElement.classList.add('js-on');
    var sel='.sec-head,.pgrid,.why-grid,.occ,.rev-grid,.circles,.ribbon,.ugc-grid,.vibe-grid,.gbp-grid,.tp-grid,.catban-grid,.row';
    var els=document.querySelectorAll(sel);
    if(!('IntersectionObserver' in window)){return;}
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
    },{threshold:.08,rootMargin:'0px 0px -40px 0px'});
    els.forEach(function(el){ el.classList.add('reveal'); io.observe(el); });
    // safety: reveal everything after 2s no matter what
    setTimeout(function(){ document.querySelectorAll('.reveal:not(.in)').forEach(function(el){el.classList.add('in');}); },2000);
  }catch(e){}

  /* ---------- Batch 5: auto-scrolling carousels ---------- */
  (function(){
    function sTo(el,left){ try{ el.scrollTo({left:left,behavior:'smooth'}); }catch(e){ el.scrollLeft=left; } }
    function scrollable(el){ return el && el.scrollWidth > el.clientWidth + 8; }

    function autoplay(track){
      try{ track.style.scrollSnapType='none'; }catch(e){}
      var dir=1, running=false, raf=null, resumeT=null;
      var SPEED=0.85; /* px per frame; raise for faster */
      function frame(){
        if(!running){ return; }
        if(scrollable(track)){
          var max=track.scrollWidth-track.clientWidth;
          var nl=track.scrollLeft+dir*SPEED;
          if(nl>=max){ nl=max; dir=-1; }
          else if(nl<=0){ nl=0; dir=1; }
          track.scrollLeft=nl;
        }
        raf=requestAnimationFrame(frame);
      }
      function start(){ if(!running){ running=true; raf=requestAnimationFrame(frame); } }
      function stop(){ running=false; if(raf){ cancelAnimationFrame(raf); raf=null; } }
      function bump(){ stop(); if(resumeT){ clearTimeout(resumeT); } resumeT=setTimeout(start,1600); }
      track._glBump=bump;
      ['pointerdown','touchstart','wheel'].forEach(function(ev){ track.addEventListener(ev,bump,{passive:true}); });
      track.addEventListener('mouseenter',stop);
      track.addEventListener('mouseleave',start);
      if('IntersectionObserver' in window){
        new IntersectionObserver(function(es){ es.forEach(function(e){ e.isIntersecting?start():stop(); }); },{threshold:0.12}).observe(track);
      } else { start(); }
    }

    window.saansFcScroll=function(btn,d){
      var w=btn.closest ? btn.closest('.fc-carousel') : null;
      var t=w?w.querySelector('.pgrid-auto'):null;
      if(t){ if(t._glBump){ t._glBump(); } var amt=Math.max(180,t.clientWidth*0.8); if(t.scrollBy){ t.scrollBy({left:d*amt,behavior:'smooth'}); } else { t.scrollLeft+=d*amt; } }
    };

    function initAll(){
      var tracks=document.querySelectorAll('.pgrid-auto, .occ, .circles, .why-grid, .tsm-track, .ugw-track');
      for(var i=0;i<tracks.length;i++){ var t=tracks[i]; if(!t.getAttribute('data-gl-auto')){ t.setAttribute('data-gl-auto','1'); autoplay(t); } }
      ugcVideos();
    }

    /* UGC cards: play the most-visible reels muted inline, pause the rest */
    function ugcVideos(){
      var vids=document.querySelectorAll('.ugw-vid'); if(!vids.length){ return; }
      if('IntersectionObserver' in window){
        var io=new IntersectionObserver(function(es){ es.forEach(function(e){ var v=e.target; if(e.isIntersecting && e.intersectionRatio>0.55){ v.play().catch(function(){}); } else { v.pause(); } }); },{threshold:[0,0.55,1]});
        for(var i=0;i<vids.length;i++){ io.observe(vids[i]); }
      } else { for(var j=0;j<vids.length;j++){ vids[j].play().catch(function(){}); } }
    }

    /* Fullscreen reel player (with sound) */
    window.saansUgcOpen=function(btn){
      var src=btn.getAttribute('data-ugc-src'); if(!src){ return; }
      var m=document.getElementById('ugcm'), v=document.getElementById('ugcmVid');
      if(v){ v.src=src; v.muted=false; try{ v.currentTime=0; }catch(e){} }
      if(m){ m.classList.add('open'); m.setAttribute('aria-hidden','false'); document.body.style.overflow='hidden'; if(v){ v.play().catch(function(){}); } }
    };
    window.saansUgcClose=function(){
      var m=document.getElementById('ugcm'), v=document.getElementById('ugcmVid');
      if(v){ v.pause(); }
      if(m){ m.classList.remove('open'); m.setAttribute('aria-hidden','true'); document.body.style.overflow=''; }
    };
    document.addEventListener('keydown', function(e){ if(e.key==='Escape'){ window.saansUgcClose(); } });
    if(document.readyState!=='loading'){ initAll(); } else { document.addEventListener('DOMContentLoaded', initAll); }
    window.addEventListener('load', function(){ setTimeout(initAll, 400); });
  })();
})();